import React from 'react'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import Checkbox from '@material-ui/core/Checkbox'

import { observer } from "mobx-react"

import {inputLabelStyle, formControlStyle } from '../Style'

import { isUndefined } from 'jimbo/utils'

const BooleanField = ({id, label, instance, store, fieldName, createItem, creationOptions, path, formConfigurations, ...rest }) => {

    const formControlClasses = formControlStyle();
    const inputLabelClasses = inputLabelStyle();

    const onChange = (evt) => {
        const isChecked = evt.target.checked
        instance.setValue(fieldName, isChecked);
    } 

    const onBlur = (evt) => {
        console.log("blurred ", fieldName )
    }

    // const value = instance[fieldName] ? instance[fieldName]: "";

    // const fieldMeta = instance.$fieldsMeta.get(fieldName);
    // const isTouched = fieldMeta.isTouched;
    // const hasErrors = fieldMeta.errors;
    

    const field = instance.$fields.get(fieldName);
    if (!isUndefined(field)){

        const touched = field.touched;
        const hasErrors = field.errors;
        const checked = field.value ? true: false;

        const showError = touched && hasErrors;

        return <FormControl error={showError} fullWidth classes={formControlClasses}>
                <InputLabel shrink={false} classes={inputLabelClasses} htmlFor={id}>
                    {label}
                </InputLabel>
                <Checkbox id={id} checked={checked} onChange={(evt) => onChange(evt)} onBlur={(evt) => onBlur(evt)} {...rest}/>
        </FormControl>
    }else{
        return (<div>
            Error: Field {fieldName} doesn't exist.
            </div>);
    }
}


export default observer(BooleanField);